module.exports = __webpack_public_path__ + "static/media/almostFinished.f2747c59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map/almostFinished.svg
// module id = 1500
// module chunks = 0